<div class="pad15 withpopupCard card">
    <div class="row">
        <div class="font16 fontbold ml-auto mr-3">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{totalCount}}&nbsp;
            <span class="font16 fontnormal" translate>lblResults</span>
        </div>
    </div>
  </div>
<div class="scrollbar dwo">
    <div class="card">
        <div class="table-responsive max-h240" infinite-scroll
        [infiniteScrollDistance]="scrollDistance"
        [infiniteScrollThrottle]="throttle"
        [scrollWindow]="false"
        (scrolled)="onScrollDown($event)">
            <table class="tablest1 fixed-header">
                <thead>
                    <tr>
                        <th style="width: 5%" scope="col">#</th>
                        <th style="width: 10%" scope="col" translate>lblCustomerMobile</th>
                        <th style="width: 15%" scope="col" sortable="AgentName" (sort)="onSort($event)" translate>lblAgentName</th>
                        <th style="width: 10%" scope="col" sortable="AgentMobile" (sort)="onSort($event)" translate>lblAgentMobile</th>
                        <th style="width: 10%" scope="col" sortable="CallStartTime" (sort)="onSort($event)" translate>lblCallDate</th>
                        <th style="width: 10%" scope="col" translate>lblDuration</th>
                        <th scope="col" translate>lblNote</th>
                        <th class="text-center" style="width: 5%" scope="col" translate>lblAction</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="lstCallHistory?.length > 0; else load_else">
                        <tr *ngFor="let call of lstCallHistory; let i=index">
                            <td>{{i+1}}</td>
                            <td>
                                <ngb-highlight [result]="call.customerMobile"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="call.agentName"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="call.agentMobile"></ngb-highlight>
                            </td>
                            <td>
                                <ngb-highlight [result]="call.callStartTime ? (getLocalDate(call.callStartTime) | date: 'short') : ''"></ngb-highlight>
                            </td>
                            <td>
                                {{ getTimeDuration(call.callStartTime, call.callEndTime) }}
                            </td>
                            <td>
                                {{call.notes?.length > 50 ? (call.notes | slice:0:50)+'..' : call.notes }}
                            </td>
                            <td class="text-center">
                                <a class="btn btn-ico line-height-30" ngbTooltip="View" (click)="ViewDetails(viewDetailContent, call)">
                                    <em class="far fa-eye fa-lg"></em>
                                </a>
                            </td>
                        </tr>
                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                            <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="row">
        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
            <button type="button" class="add-button btn btn-secondary btn-lg" (click)="OnClose()"
                translate>lblCancel</button>
        </div>
    </div>
</div>

<!-- Popup for View Call detail -->
<ng-template #viewDetailContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblDetails</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <div class="card scrollbar">
            <div class="card-content">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 af-form-group">
                            <div class="row">
                                <div class="col">
                                    <strong translate class="font-14">lblCallDate</strong>
                                    <div>{{ callDetail.callStartTime ? (getLocalDate(callDetail.callStartTime) | date: 'short') : '' }}</div>
                                </div>
                                <div class="col">
                                    <strong translate class="font-14">lblDuration</strong>
                                    <div>{{ getTimeDuration(callDetail.callStartTime, callDetail.callEndTime) }}</div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <strong translate class="font-14">lblCustomerName</strong>
                                    <div>{{ customerService.customerDetail.customerName }}</div>
                                </div>
                                <div class="col">
                                    <strong translate class="font-14">lblCustomerMobile</strong>
                                    <div>{{ callDetail.customerMobile }}</div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <strong translate class="font-14">lblAgentName</strong>
                                    <div>{{ callDetail.agentName }}</div>
                                </div>
                                <div class="col">
                                    <strong translate class="font-14">lblAgentMobile</strong>
                                    <div>{{ callDetail.agentMobile }}</div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <strong translate class="font-14">lblNote</strong>
                                    <div [innerHtml]="callDetail.notes" class="comm-body-scroll form-control"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md" (click)="modal.close('Cancel click')" translate>lblCancel</button>
    </div>
</ng-template>